<template>
  <div class="gc-grid-footer">
    <div class="gc-grid-footer-left">
      <div class="gc-grid-footer-item">
        <label class="gc-footer-label">Item Count</label>
        <GcFooterValue :value="ItemCount" :format="'Decimal-6-0'" :length="2" />
      </div>
    </div>
    <div class="gc-grid-footer-right">
      <div class="gc-grid-footer-item">
        <label class="gc-footer-label">Sub Total ({{ CurrencyCode }})</label>
        <GcFooterValue
          :value="ExTaxTotal"
          :format="'Decimal-4-2C'"
          :length="6"
        />
      </div>
      <div class="gc-grid-footer-item">
        <label class="gc-footer-label">Tax ({{ CurrencyCode }})</label>
        <GcFooterValue :value="TaxTotal" :format="'Decimal-4-2C'" :length="6" />
      </div>
      <div class="gc-grid-footer-item">
        <label class="gc-footer-label">Total ({{ CurrencyCode }})</label>
        <GcFooterValue :value="Total" :format="'Decimal-4-2C'" :length="6" />
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";
export default {
  props: ["CurrencyCode", "ItemCount", "ExTaxTotal", "TaxTotal", "Total"],

  mixins: [BaseViewMixin],
};
</script>

<style lang="scss">
.gc-grid-footer {
  display: flex;
  background: #525464;
  color: white;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;

  .gc-grid-footer-left {
    display: flex;
    flex-grow: 1;
  }

  .gc-grid-footer-right {
    display: flex;
  }

  .gc-footer-label {
    margin-left: 15px;
    font-size: 14px;
    padding-bottom: 0px;
    padding-right: 10px;
  }

  .gc-footer-amount {
    font-size: 20px;
    padding-bottom: 0px;
  }
  .gc-grid-footer-item {
    align-items: baseline !important;
    padding-left: 10px;
    padding-right: 5px;
  }
}
</style>
